import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';

/**
 * Simple component to show circular progress centered within most app components;
 * @param { props } props 
 * @param { object } style additional styles to be applied to component
 */
const CenteredCircularProgress = ({style}) => (
  <Grid container justify="center" style={style}>
    <Grid item>
      <CircularProgress />
    </Grid>
  </Grid>
);

export default CenteredCircularProgress;
